import React from 'react';
import { Table, Input, Button, Row, Col, Card, FormGroup, Label, CardBody, Spinner, Alert, Tooltip } from 'reactstrap';
import { connect } from 'react-redux';

import AdminNavbar from "./components/Navbars/AdminNavbar.jsx";
import Footer from "./components/Footer/Footer.jsx";

import SingleDemo from './views/SingleDemo.jsx';

class DashboardSingleDemo extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			qClientColor: "#AAD3FF",
			backgroundColor: "#051613",
			sidebarOpened:
				document.documentElement.className.indexOf("nav-open") !== -1
		};
	}

	componentDidMount() {
		console.log('qui')
	}

	render() {
		return (
			<div className="content">
				<div className="wrapper">
					<div
						className="main-panel"
						ref="mainPanel"
						data={this.state.qClientColor}
					>
						<AdminNavbar
							{...this.props}
							backgroundColor={this.state.backgroundColor}
							qClientColor={this.state.qClientColor}
							toggleSidebar={this.toggleSidebar}
							sidebarOpened={this.state.sidebarOpened}
							user={this.props.user}
						/>
						<SingleDemo {...this.props} user={this.props.user} />

						{// we don't want the Footer to be rendered on map page
							this.props.location.pathname.indexOf("maps") !== -1 ? null : (
								<Footer fluid />
							)}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(DashboardSingleDemo);
